import { request } from '@/shared/api/request'

export const getDataByBin = (params) => request({ url: '/contract/reorganize/check', method: 'GET', params })

export const getEmployerPermissionByBin = (bin) => request({ url: `/contract/universalMethods/irs/permission?bin=${bin}`, method: 'GET' })

export const getReorganizeXml = (data) => request({ url: '/contract/reorganize/xmlList', method: 'POST', data })

export const sendSignedXml = (data) => request({ url: '/contract/reorganize/send', method: 'POST', data })

export const irsDownloadExcel = (params) => request({ url: `/contract/universalMethods/irs/downloadExcel`, method: 'GET', params, responseType: 'blob' })

